/**
 * Buzón de quejas, reclamos y sugerencias — LABSYSO (F-PGC-6-1)
 * Requisito de auditoría: canal visible + flujograma del procedimiento.
 */

export const LABSYSO_FEEDBACK = {
  formCode: "F-PGC-6-1, edición 3",
  title: "Buzón de Quejas, Reclamos y Sugerencias",
  subtitle:
    "Agradecemos sus comentarios y sugerencias para mejorar nuestros servicios. Por favor, complete el siguiente formulario con la información requerida.",
  flowchartPdfUrl: "/labsyso/flujograma-quejas-reclamos-sugerencias.pdf",
  formPdfUrl: "/labsyso/buzon-quejas-sugerencias-f-pgc-6-1.pdf",
  analysisDeadlineDays: 5,
  evaluationDeadlineDays: 5,
};
